function scroll_timelines__venue() {
  const shapes = document.querySelectorAll('svg path[data-path-from]');
  if( typeof(shapes) != 'undefined' && shapes != null ) {
    shapes.forEach( element => {
      element.animate(
        {
          d: [
            'path("' + element.dataset.pathFrom + '")',
            'path("' + element.dataset.pathTo + '")',
          ]
        },
        {
          duration: 1, // required, but does nothing
          fill: 'both',
          timeline: new ScrollTimeline({
            scrollOffsets: [
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top + parseInt(element.dataset.offsetFrom)),
              CSS.px(window.pageYOffset + element.getBoundingClientRect().top + parseInt(element.dataset.offsetTo))
            ]
          })
        }
      )
    });
  }
}

jQuery( document ).ready(function() {
  if (document.querySelector('body.single-venue, body.single-kcma, body.page-template-template-careers-landing, body.page-template-template-careers-role-detail') ) {
    // scroll_timelines__venue();
  }
});

// window.addEventListener('scroll', function() {
//   console.log(document.documentElement.scrollTop);
// });
